import request from 'superagent';

const groups = {

};

const JsonRpc = function(endpoint, namespace) {
	this.endpoint = endpoint;
	this.namespace = namespace;
};

JsonRpc.prototype.call = function(method, args, callback, name) {
	const reqid = Math.round(Math.random() * 1000000);
	const csrf = args._token;
	delete args._token;
	const jsonRequest = this.buildRequest(method, {params: args}, reqid);
	if (name && groups[name]) {
		groups[name].request.abort();
	}
	const req = request
		.post(this.endpoint)
		.type('application/json')
		.set('X-Token', csrf);

	if (window.XAuth) {
		req.set('X-Auth-Token', window.XAuth);
	}

	req.send(jsonRequest)
		.end((err, res) => {
			if (err) {
				try {
					let response = JSON.parse(res.text);
					if (response.error) {
						callback(response.error, null);
					}
					else {
						callback(response);
					}
				}
				catch (e) {
					callback(err);
				}
			}
			else {
				try {
					let response = JSON.parse(res.text);
					if (response.error) {
						callback(response.error, null);
					}
					else {
						callback(null, response.result);
					}
				}
				catch (e) {
					callback(res, null);
				}
			}
		});
	if (name) {
		groups[name] = {
			id: reqid,
			request: req
		};
	}
};

JsonRpc.prototype.buildRequest = function(method, options, id) {
	let reqid = id ? id : 1;
	const dataObj = {
		jsonrpc: '2.0',
		method: this.namespace ? this.namespace +'.'+ method : method,
		id: reqid
	};
	if(options.params !== undefined) {
		dataObj.params = options.params;
	}
	return dataObj;
};

export default JsonRpc;


// WEBPACK FOOTER //
// ./src/utils/transport/jsonrpc.js